import { Outlet, useNavigate } from 'react-router-dom';
import { useState, useEffect, useContext } from 'react';
import { ContextSession } from '../services/ContextSession';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

function RootLayout() {
  const sessi = useContext(ContextSession);
  const navigate = useNavigate();
  const [sessionExpired, setSessionExpired] = useState(false);

  // Redirige al inicio si ya tiene sesión activa al cargar
  useEffect(() => {
    const rawData = sessi.getDataST();
    let data = null;
    if (rawData) {
      try {
        data = JSON.parse(rawData);
      } catch (error) {
        localStorage.removeItem('authData');
      }
    }
    let token = sessi.getToken();

    if (data != null)
      if (data.token.length > 2 && data.token !== "NA") {
        sessi.setDataAuth();
        navigate("/inicio");
      } else if ((token !== "0" || token !== 0 || token !== "NA") && token.length > 1) {
        navigate('/');
      } else {
        navigate('/inicio');
      }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Escucha el evento global de sesión expirada lanzado por apiRequest
  useEffect(() => {
    const handleExpired = () => setSessionExpired(true);
    window.addEventListener('session-expired', handleExpired);
    return () => window.removeEventListener('session-expired', handleExpired);
  }, []);

  const handleAcceptExpired = () => {
    setSessionExpired(false);
    sessi.clearSession();
    navigate('/');
  };

  return (
    <>
      <Outlet />

      <Dialog open={sessionExpired} disableEscapeKeyDown>
        <DialogTitle>Sesión expirada</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Su sesión ha expirado. Por favor inicie sesión nuevamente.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleAcceptExpired}>
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default RootLayout;
